import { render } from "./CheckoutPaymentMethods.vue?vue&type=template&id=4d15abef"
import script from "./CheckoutPaymentMethods.vue?vue&type=script&lang=js"
export * from "./CheckoutPaymentMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__